import { useCallback, useState } from 'react';

import { ErdOverlayType, OverlayState } from '../types';

const DEFAULT_STATE: OverlayState = {
  relationshipTests: true,
  semanticLayer: true,
  heuristicInferred: true,
  fusionSql: false,
};

export function useOverlayState() {
  const [overlays, setOverlays] = useState<OverlayState>(DEFAULT_STATE);

  const toggleOverlay = useCallback((overlay: ErdOverlayType) => {
    if (overlay === 'fusionSql') return;
    setOverlays((prev) => ({
      ...prev,
      [overlay]: !prev[overlay],
    }));
  }, []);

  return { overlays, toggleOverlay };
}
